import axios from 'axios'
import store from '../../store/index.js'

const BASE_URL = store.state.api.baseUrl
const headers = { Authorization: `Bearer ${store.state.user.attributes.token}` }

function participantDocumentActions (pIdParticipantDocument) {
    const URI = `${BASE_URL}/api/participantDocuments/${pIdParticipantDocument}/actions`
    return axios.get(URI, { headers })
}

export { participantDocumentActions }